import store from "../core/redux/store";
import {
  set_language,
  set_translation,
  set_languages,
  set_category_list,
  set_subcategory_list,
  set_dropdowns_list
} from "../core/redux/action";
import { getUrls } from "../api/apiurls.js";

var tenantType = getUrls().tenantType;

const transformData = (data) => {
  const result = { languages: [] };
  const processLanguage = (item, languageKey, parentName) => {
    const languageName = languageKey.split("-")[0].toLowerCase();
    const lang = languageKey.split("-")[1].toLowerCase();
    if (!result[languageName]) {
      result[languageName] = {};
      result.languages.push({
        key: languageName,
        name: lang.charAt(0).toUpperCase() + lang.slice(1),
      });
    }

    item[languageKey].forEach((entry) => {
      result[languageName][parentName] = entry.name;
      Object.keys(entry).forEach((key) => {
        if (key !== "name") processLanguage(entry, key, parentName);
      });
    });
  };
  data.forEach((item) => {
    Object.keys(item).forEach((key) => {
      if (key !== "name") processLanguage(item, key, item.name);
    });
  });

  return result;
};

function addSuffixToJsonUrl(url, suffix) {
  if (suffix != "" ) {
    return url.replace(/\.json$/, `_${suffix}.json`);
  }
  return url;
}
// const tenantId = localStorage.getItem("tenantId");

const fetchTranslations = async () => {
  try {
  
    console.log("getUrls().translationLink",getUrls().translationLink);
    let translationLink = getUrls().translationLink;
    tenantType = localStorage.getItem("tenantWebId") || tenantType;
  
    if (tenantType == "all" || !tenantType || tenantType == "null") {
      tenantType = "";
    }

    const suffix = tenantType;
    translationLink = addSuffixToJsonUrl(translationLink, suffix);
    console.log("translationLink New", translationLink);

    const response1 = await fetch(translationLink);
    const response2 = await response1.json();
    const trns = transformData(response2["translate-key"]);
    // let categories = response?.data?.categories;
   
    const languages = trns["languages"];
    store.dispatch(set_languages(languages));
    localStorage.setItem("languages", JSON.stringify(languages));
    return { data: trns, languages };
  } catch (error) {
    console.error("Error fetching translations:", error);
    return [];
  }
};

export const loadResources = async (loginTenantId) => {
  if(loginTenantId != "" && (loginTenantId == "n4Xc96g6qyNcrq5dD" || loginTenantId == "jNrhXAynhAbQkrj8Y" || loginTenantId == "8wNWEtTEdgoywriNX"))
  {
    localStorage.setItem("tenantWebId", loginTenantId);
  }
  let iLanguage = localStorage.getItem("language");
  const translation = localStorage.getItem("translation");
  let iTranslation = "";
  if(translation != "undefined")
  {
    iTranslation = JSON.parse(localStorage.getItem("translation") || "[]");
  }
  if (iLanguage) {
    store.dispatch(set_language(iLanguage));
  } else {
    //Pick browser language
    var userLang = navigator.language || navigator.userLanguage;
    store.dispatch(set_language(userLang.split("-")[0]));
  }

  if (iTranslation) {
    store.dispatch(set_translation(iTranslation));
  }
  const translations = await fetchTranslations();
  const resources = translations.data;
  //
  store.dispatch(set_translation(resources));
  
  return resources;
};

const allowedTenantIds = ["n4Xc96g6qyNcrq5dD", "jNrhXAynhAbQkrj8Y", "8wNWEtTEdgoywriNX"];
const fetchCategories = async (tenantid) => {
 
  let dropDownData = null;
  try {
    if(tenantid && tenantid != "")
    {
      try
      {
        let url = "https://resources.wizztech.us/static/ebuyings_dropdown.json";
        if(allowedTenantIds.includes(tenantid))
          url = "https://resources.wizztech.us/static/ebuyings_dropdown_"+tenantid+".json";
      
        const response1 = await fetch(url);
        dropDownData  = await response1.json();
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      }
    }

    const response2 = await fetch("https://resources.wizztech.us/static/ebuyings_categories.json");
    const response  = await response2.json();
   
    let categories = response || [];
    let dropDown = dropDownData || [];


    return { categories, dropDown };
  } catch (error) {
    console.error("Error fetching translations:", error);
    return [];
  }
};
export const loadCategoriesAndDropDown = async (_tenantid) => {

  let tenantid = _tenantid;
  if(!tenantid)
  {
    const val = localStorage.getItem("tenantId"); 
    tenantid = val ? val : "";
  }

  const translations = await fetchCategories(tenantid);

  const filteredData = translations.categories || [];
  
  // 1. Extract categories where subcategory is empty and create {_id: category, name: category} structure
  const categories = filteredData?.filter((item) => 
    (
      item.subcategory == "" || item.subcategory == null
    ))
    .map((item) => ({
      _id: item.category,
      name: item.category,
      tenantid: item.tenantid,
    })).sort((a, b) => (a.name || "").localeCompare(b.name || ""));


  // 2. Extract subcategories and create {_id: subcategory, name: subcategory, categoryId: category, categoryName: category} structure
  const subcategories = filteredData?.filter((item) => 
    (item.subcategory !== "" && item.subcategory != null && item.tenantid == tenantid))
    .map((item) => ({
      _id: item.subcategory,
      name:item.subcategory,
      categoryId: item.category,
      categoryName: item.category,
    }));
    //.sort((a, b) => (a.name || "").localeCompare(b.name || ""));

    const dropDowns = translations?.dropDown;//?.sort((a, b) => (a.value || "").localeCompare(b.value || ""));
    console.log("dropDowns dropDowns");


    // dropDowns.sort((a, b) => (a.value || "").localeCompare(b.value || ""));

// console.log(sortedData);


  if(filteredData)
  {
      console.log("before set_category_list");
    store.dispatch(set_category_list(categories));
    store.dispatch(set_subcategory_list(subcategories));
  }
  if(dropDowns)
  {   console.log("before set_dropdowns_list");
    store.dispatch(set_dropdowns_list(dropDowns));
  }  

  console.log("after dispatch");
};
await loadCategoriesAndDropDown() 
await loadResources(localStorage.getItem("tenantId")?localStorage.getItem("tenantId"):"");
